import React, { useState } from "react";
import "./deleteIcon.css";
import { DeleteIconProps } from "./interface";
import TagUtil from "../../utils/readUtils/tagUtil";
import DeletePopup from "../dialogs/deletePopup";
import { XIcon } from "lucide-react";
import toast from "react-hot-toast";
import api from "../../utils/axios";
declare var window: any;

function DeleteIcon(props: DeleteIconProps) {
  const [isOpenDelete, setIsOpenDelete] = useState(false);

  const handleDelete = () => {
    console.log('pro', props)
    let deleteItems =
      props.mode === "notes"
        ? props.notes
        : props.mode === "tags"
        ? TagUtil.getAllTags()
        : props.bookmarks;
    let deleteFunc = props.mode === "notes" ? props.handleFetchNotes : props.handleFetchBookmarks;
    deleteItems.forEach((item: any, index: number) => {
      if (props.mode === "tags") {
        item === props.tagName && TagUtil.clear(item);
        handleDeleteTagFromNote(item);
        return;
      }
      if (item.id === props.id) {
        deleteItems.splice(index, 1);
        if (props.mode === "notes") {
          api.delete(`/api/highlights/${item.key}`);
        }
        if (deleteItems.length === 0) {
          window.localforage
            .removeItem(props.mode)
            .then(() => {
              deleteFunc();
              toast.success(props.t("Deletion successful"));
            })
            .catch(() => {
              console.log("delete failed");
            });
        } else {
          window.localforage
            .setItem(props.mode, deleteItems)
            .then(() => {
              deleteFunc();
              toast.success(props.t("Deletion successful"));
            })
            .catch(() => {
              console.log("modify failed");
            });
        }
      }
    });
  };

  const handleDeleteTagFromNote = (tagName: string) => {
    let noteList = props.notes.map((item) => {
      return {
        ...item,
        tag: item.tag.filter((subitem) => subitem !== tagName),
      };
    });
    window.localforage.setItem("notes", noteList).then(() => {
      props.handleFetchNotes();
    });
  };

  const handleDeletePopup = (isOpenDelete: boolean) => {
    setIsOpenDelete(isOpenDelete);
    if (!isOpenDelete) {
      props.handleChangeTag(props.index);
    }
  };

  const deletePopupProps = {
    name: props.tagName,
    title: "Delete this tag",
    description: "This action will clear and remove this tag",
    handleDeletePopup: handleDeletePopup,
    handleDeleteOpearion: handleDelete,
  };

  return (
    <>
      {isOpenDelete && <DeletePopup {...deletePopupProps} />}
      <div
        className="delete-digest-button"
        onClick={() => {
          props.mode === "tags" ? handleDeletePopup(true) : handleDelete();
        }}
      >
        <div className="relative text-sm cursor-pointer p-1 rounded-full">
          <XIcon className="w-3 h-3" />
        </div>
      </div>
    </>
  );
}

export default DeleteIcon;
